import { useMemo } from 'react';
import { Outlet } from '@tanstack/react-router';

import { TrialBanner } from '../TrialBanner';
import { BookingFeesNotice } from '../BookingFees';
import { FolderTabs } from './FolderTabs';
import { PhoneBar } from './PhoneBar';
import { SettingsIndex, useSheetNav } from './SheetNav';
import { TopBar } from './TopBar';
import { useNavModel } from './useNavModel';
import { navOrder } from './navModel';
import { ScreenEntrance } from './ScreenEntrance';

/**
 * The Helios CRM's structure in Dale's colors: a glass bar on top, folder tabs,
 * and one sheet where every page lives. Routes and functions are the panel's own.
 */
export function HeliosShell() {
  const model = useNavModel();
  const { settings, pills } = useSheetNav(model);
  const order = useMemo(() => navOrder(model), [model]);
  return (
    <div className="hs-app">
      <div className="hs-backdrop" aria-hidden="true" />
      <TopBar model={model} />
      <FolderTabs model={model} />
      <section className="hs-sheet" data-settings={settings || undefined}>
        {settings ? <SettingsIndex links={model.settings} /> : null}
        <main className="shell-main hs-screen">
          <TrialBanner />
          <BookingFeesNotice />
          {pills}
          <ScreenEntrance order={order}>
            <Outlet />
          </ScreenEntrance>
        </main>
      </section>
      <PhoneBar model={model} />
    </div>
  );
}
